import { connect } from 'react-redux';
import { getTranslation } from "../../../reducers/common/localization";
import NotificationSettings from "./NotificationSettings";
import {
    fetchGetUserSettings, 
    fetchUpdateUserSettings, 
    getUserSettingsData, 
    getUserSettingsLoading, 
    clearUserSettings
} from "../../../reducers/account/userSettings";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: getUserSettingsLoading(state),
        data: getUserSettingsData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => dispatch(fetchGetUserSettings()),
        onUnmount: () => dispatch(clearUserSettings()),
        onUserSettingsUpdate: data => dispatch(fetchUpdateUserSettings(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettings);



// WEBPACK FOOTER //
// ./src/components/accountManagement/notificationSettings/NotificationSettings.container.js